import { getShareModalConfig } from 'lib/customer/getShareModalConfig'
import { useMemo, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAppSelector, useAppDispatch } from './reduxHooks'
import type { ShareConfig } from 'components/Common/Modals/ShareModal/ShareModal'
import { fetchMyReferralCode } from 'actions/ReferAction'
import appConfig from 'constants/config'
import useShareVariant from './useShareVariant'
import { SHARE_SOCIETE_POINTS_EARN_KEY } from 'constants/share'

interface Props {
  utmCampaign?: string
  location?: string
  offerId: string
  image?: App.Image
  queryString?: string
  type: 'offer' | 'bedbankOffer' | 'experience' | 'carHire'
  offerType?: 'hotel' | 'tour' | 'tour_v2' | 'cruise' | 'bedbank_hotel'
}

function useShareModalConfig(props: Props): ShareConfig {
  const url = useAppSelector((state) => state.system.customerPortalURL)
  const memberId = useAppSelector((state) => state.auth.account.memberId)
  const pathname = useAppSelector((state) => state.router.location.pathname)
  const region = useAppSelector((state) => state.geo.currentRegionCode)
  const referralCode = useAppSelector((state) => state.refer.referralCode)
  const dispatch = useAppDispatch()
  const shareVariant = useShareVariant()
  const intl = useIntl()

  useEffect(() => {
    if (memberId && !referralCode && appConfig.ENABLE_SHARE_LINK_WITH_REFERRAL_CODE) {
      dispatch(fetchMyReferralCode(memberId))
    }
  }, [memberId, referralCode, dispatch])

  const config = useMemo(() => {
    const searchParams = new URLSearchParams(props.queryString || '')

    if (referralCode && !searchParams.has('referralCode')) {
      searchParams.set('referralCode', referralCode)
      searchParams.set('sek', SHARE_SOCIETE_POINTS_EARN_KEY)
    }

    return getShareModalConfig({
      customerPortalURL: url,
      memberId,
      offerId: props.offerId,
      offerLocation: props.location,
      pathname,
      region,
      type: props.type,
      utmCampaign: props.utmCampaign,
      image: props.image,
      queryString: searchParams.toString(),
      offerType: props.offerType,
      shareVariant,
      intl,
    })
  }, [
    props.image,
    props.location,
    props.offerId,
    props.utmCampaign,
    props.type,
    url,
    memberId,
    pathname,
    region,
    props.queryString,
    props.offerType,
    referralCode,
    shareVariant,
    intl,
  ])

  return config
}

export default useShareModalConfig
